<template>
  <td :class="{ 'table-danger': isDeleted }">
    <div>
      <router-link :to="link">
        <img
          height="45"
          width="45"
          class="rounded-circle mr-2 link"
          :src="src"
        />
        {{ content.name }}
        <i v-if="content.sex == 'männlich'" class="fas fa-mars male-icon"></i>
        <i
          v-else-if="content.sex == 'weiblich'"
          class="fas fa-venus female-icon"
        ></i>
      </router-link>
      <i class="fas fa-comments message-icon"></i>
      {{ content.count }}
    </div>
  </td>
</template>

<script lang="babel">
export default {
  props: ['content'],
  computed: {
    src () {
      return `${this.content.primary_image.url}?width=45&height=45`;
    },
    isDeleted() {
      return this.content.deleted_at !== null;
    },
    link () {
      return this.content.is_fake ?
        `/fake/kartei/${this.content.id}` :
        `/mitglieder/kartei/${this.content.id}`;
    },
  }
};
</script>

<style scoped lang="scss">
.message-icon {
  margin-left: 40px;
}
.male-icon {
  color: $male;
}
.female-icon {
  color: $female;
}
</style>
